var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplianceMsgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    viewBox: "0 0 18.45 17.478",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "AutoRespond",
    transform: "translate(-0.1 -0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2583",
    "data-name": "Path 2583",
    d: "M7.7,13.362H4.357L1.4,16.314a.383.383,0,0,1-.654-.273V2.553a1.8,1.8,0,0,1,1.8-1.8H15.165a1.8,1.8,0,0,1,1.8,1.8v5.22",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_189",
    "data-name": "Line 189",
    x2: 10.897,
    transform: "translate(3.265 6.04)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_190",
    "data-name": "Line 190",
    x2: 5.398,
    transform: "translate(3.265 8.58)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_191",
    "data-name": "Line 191",
    x2: 10.897,
    transform: "translate(3.265 3.5)",
    fill: "none",
    stroke: "#787f88",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2584",
    "data-name": "Path 2584",
    d: "M18.87,12.73a4.61,4.61,0,1,0,4.61,4.61A4.61,4.61,0,0,0,18.87,12.73Zm2.165,6.223a2.91,2.91,0,0,0-2.407-.857v.826a.184.184,0,0,1-.184.184.189.189,0,0,1-.127-.051l-1.873-1.765a.175.175,0,0,1-.006-.254l.006-.006,1.867-1.765a.182.182,0,0,1,.26.006.177.177,0,0,1,.051.127v.826a2.5,2.5,0,0,1,2.724,2.591.184.184,0,0,1-.318.14h0Z",
    transform: "translate(-4.931 -4.372)",
    fill: "#787f88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceMsgIcon);
export default __webpack_public_path__ + "static/media/compliance-Msg-icon.b9b7889c0534146317eb9bc56914ab18.svg";
export { ForwardRef as ReactComponent };